<template>
    <div class="wrapper-devices">
        <p>
            Quais aparelhos você
            <br />possui com acesso a internet?
        </p>
        <p class="obs">*É possível selecionar mais de uma opção.</p>
        <div class="slide">
            <ul>
                <li
                    :class="{ btn: selected2.includes(devices[0].id) }"
                    @click="
                        selected2.includes(devices[0].id)
                            ? (selected2.splice(selected2.indexOf(devices[0].id), 1),
                              selectedPoint.splice(selectedPoint.indexOf(devices[0].point), 1))
                            : (selected2.push(devices[0].id), selectedPoint.push(devices[0].point)),
                            addPlanMulti()
                    "
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="smartphone"
                        viewBox="0 0 105.514 184.086"
                    >
                        <g :fill="iconColor" transform="translate(0.1 0.1)">
                            <g transform="translate(39.787 5.521)">
                                <path
                                    :fill="iconColor"
                                    d="M186.573,1337.2h-23.45a1.011,1.011,0,1,1,0-2.022h23.45a1.011,1.011,0,1,1,0,2.022Zm-23.45-1.714a.7.7,0,0,0,0,1.407h23.45a.7.7,0,1,0,0-1.407Z"
                                    transform="translate(-162.111 -1335.179)"
                                />
                            </g>
                            <g transform="translate(1.565)">
                                <path
                                    :fill="iconColor"
                                    d="M214.1,1513.8H139.41a13.765,13.765,0,0,1-13.749-13.749V1343.663a13.765,13.765,0,0,1,13.749-13.749H214.1a13.765,13.765,0,0,1,13.749,13.749v156.387A13.765,13.765,0,0,1,214.1,1513.8ZM139.41,1330.963a12.716,12.716,0,0,0-12.7,12.7v156.387a12.715,12.715,0,0,0,12.7,12.7H214.1a12.714,12.714,0,0,0,12.7-12.7V1343.663a12.715,12.715,0,0,0-12.7-12.7Z"
                                    transform="translate(-125.661 -1329.914)"
                                />
                            </g>
                            <g transform="translate(0 43.717)">
                                <path
                                    :fill="iconColor"
                                    d="M124.5,1371.605h1.757v11.91H124.5a.33.33,0,0,1-.33-.33v-11.25a.33.33,0,0,1,.33-.329Z"
                                    transform="translate(-124.168 -1371.605)"
                                />
                            </g>
                            <g transform="translate(0 30.047)">
                                <path
                                    :fill="iconColor"
                                    d="M124.5,1358.569h1.757v11.91H124.5a.33.33,0,0,1-.33-.329V1358.9a.33.33,0,0,1,.33-.33Z"
                                    transform="translate(-124.168 -1358.569)"
                                />
                            </g>
                            <g transform="translate(103.227 30.047)">
                                <path
                                    :fill="iconColor"
                                    d="M224.368,1370.479h-1.757v-11.91h1.757a.33.33,0,0,1,.33.33v11.25a.33.33,0,0,1-.33.329Z"
                                    transform="translate(-222.611 -1358.569)"
                                />
                            </g>
                            <g transform="translate(4.963 3.369)">
                                <path
                                    :fill="iconColor"
                                    d="M213.582,1510.275H139.608a10.719,10.719,0,0,1-10.707-10.707V1343.837a10.721,10.721,0,0,1,10.707-10.708h8.584a.262.262,0,0,1,.262.262v2.3a4.854,4.854,0,0,0,4.847,4.848H199.89a4.854,4.854,0,0,0,4.847-4.848v-2.307a.262.262,0,0,1,.262-.262h8.584a10.719,10.719,0,0,1,10.707,10.707v155.733A10.719,10.719,0,0,1,213.582,1510.275Zm-73.974-176.621a10.2,10.2,0,0,0-10.183,10.183v155.731a10.194,10.194,0,0,0,10.183,10.183h73.974a10.194,10.194,0,0,0,10.183-10.183V1343.834a10.194,10.194,0,0,0-10.183-10.183h-8.322v2.045a5.379,5.379,0,0,1-5.371,5.372H153.3a5.379,5.379,0,0,1-5.371-5.372v-2.042Z"
                                    transform="translate(-128.901 -1333.127)"
                                />
                            </g>
                            <g transform="translate(28.402 5.218)">
                                <path
                                    :fill="iconColor"
                                    d="M152.569,1337.518a1.314,1.314,0,1,1,1.316-1.314.154.154,0,0,1-.308,0,1.007,1.007,0,1,0-1.008,1.008.153.153,0,1,1,0,.306Z"
                                    transform="translate(-151.254 -1334.89)"
                                />
                            </g>
                            <g transform="translate(29.146 5.96)">
                                <ellipse
                                    :fill="iconColor"
                                    cx="0.572"
                                    cy="0.572"
                                    rx="0.572"
                                    ry="0.572"
                                />
                            </g>
                        </g>
                    </svg>
                    <p class="device-name">{{ devices[0].name }}</p>
                </li>
                <li
                    :class="{ btn: selected2.includes(devices[1].id) }"
                    @click="
                        selected2.includes(devices[1].id)
                            ? (selected2.splice(selected2.indexOf(devices[1].id), 1),
                              selectedPoint.splice(selectedPoint.indexOf(devices[1].point), 1))
                            : (selected2.push(devices[1].id), selectedPoint.push(devices[1].point)),
                            addPlanMulti()
                    "
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="tablet"
                        viewBox="0 0 158.93 215.666"
                    >
                        <g transform="translate(0.1 0.1)">
                            <g transform="translate(0 43.731)">
                                <path
                                    :fill="iconColor"
                                    d="M288.454,1361.175h1.738v16.576h-1.738a.375.375,0,0,1-.374-.375h0V1361.55a.375.375,0,0,1,.374-.375Z"
                                    transform="translate(-288.08 -1361.175)"
                                />
                            </g>
                            <g transform="translate(0 24.71)">
                                <path
                                    :fill="iconColor"
                                    d="M288.454,1345.214h1.738v16.576h-1.738a.375.375,0,0,1-.374-.376h0v-15.825a.375.375,0,0,1,.374-.374Z"
                                    transform="translate(-288.08 -1345.214)"
                                />
                            </g>
                            <g transform="translate(156.617 24.709)">
                                <path
                                    :fill="iconColor"
                                    d="M421.236,1361.789H419.5v-16.576h1.738a.375.375,0,0,1,.375.375h0v15.825a.376.376,0,0,1-.375.376Z"
                                    transform="translate(-419.498 -1345.213)"
                                />
                            </g>
                            <g transform="translate(1.515)">
                                <path
                                    :fill="iconColor"
                                    d="M438.5,1539.946H295.906a6.562,6.562,0,0,1-6.555-6.555V1331.034a6.562,6.562,0,0,1,6.555-6.554H438.5a6.563,6.563,0,0,1,6.555,6.554v202.356A6.563,6.563,0,0,1,438.5,1539.946Zm-142.59-214.274a5.369,5.369,0,0,0-5.363,5.363v202.356a5.368,5.368,0,0,0,5.363,5.363H438.5a5.369,5.369,0,0,0,5.363-5.363V1331.034a5.369,5.369,0,0,0-5.363-5.363Z"
                                    transform="translate(-289.351 -1324.48)"
                                />
                            </g>
                            <g transform="translate(5.457 8.72)">
                                <path
                                    :fill="iconColor"
                                    d="M440.176,1523.387H292.957a.3.3,0,0,1-.3-.3V1332.095a.3.3,0,0,1,.3-.3H440.176a.3.3,0,0,1,.3.3v190.994A.3.3,0,0,1,440.176,1523.387Zm-146.921-.6H439.878v-190.4H293.255Z"
                                    transform="translate(-292.659 -1331.797)"
                                />
                            </g>
                            <g transform="translate(75.862 203.987)">
                                <path
                                    :fill="iconColor"
                                    d="M355.239,1502.651a3.5,3.5,0,1,1,3.5-3.5.3.3,0,0,1-.6,0,2.907,2.907,0,1,0-2.908,2.907.3.3,0,0,1,0,.6Z"
                                    transform="translate(-351.736 -1495.646)"
                                />
                            </g>
                            <g transform="translate(77.573 3.164)">
                                <path
                                    :fill="iconColor"
                                    d="M354.963,1330.717a1.791,1.791,0,1,1,1.791-1.792.175.175,0,0,1-.35,0,1.441,1.441,0,1,0-1.441,1.443.175.175,0,1,1,0,.349Z"
                                    transform="translate(-353.172 -1327.135)"
                                />
                            </g>
                            <g transform="translate(78.493 3.984)">
                                <path
                                    :fill="iconColor"
                                    d="M354.815,1328.793l.1-.97a.975.975,0,1,1-.969,1.41Z"
                                    transform="translate(-353.944 -1327.823)"
                                />
                            </g>
                        </g>
                    </svg>
                    <p class="device-name">{{ devices[1].name }}</p>
                </li>
                <li
                    :class="{ btn: selected2.includes(devices[2].id) }"
                    @click="
                        selected2.includes(devices[2].id)
                            ? (selected2.splice(selected2.indexOf(devices[2].id), 1),
                              selectedPoint.splice(selectedPoint.indexOf(devices[2].point), 1))
                            : (selected2.push(devices[2].id), selectedPoint.push(devices[2].point)),
                            addPlanMulti()
                    "
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="tablet"
                        viewBox="0 0 130.121 60.375"
                    >
                        <g transform="translate(0.1 0.1)">
                            <path
                                :fill="iconColor"
                                d="M1711.623,1467.766h-.243a29.749,29.749,0,0,1-24.623-13.378l-20.852-.165a29.749,29.749,0,0,1-24.594,12.987h-.239a29.811,29.811,0,0,1-.272-59.617l71.785.568h.012a30,30,0,0,1,28.825,30.037,29.807,29.807,0,0,1-29.8,29.57Zm-45.989-14.569h0l21.4.169a.51.51,0,0,1,.425.232,28.733,28.733,0,0,0,23.925,13.144h.235a28.783,28.783,0,0,0,28.776-28.556,28.968,28.968,0,0,0-27.829-29.006l-71.765-.568a28.788,28.788,0,0,0,.275,57.571h.23a28.731,28.731,0,0,0,23.9-12.763A.512.512,0,0,1,1665.634,1453.2Z"
                                transform="translate(-1611.501 -1407.591)"
                            />
                            <g transform="translate(6.115 6.119)">
                                <path
                                    :fill="iconColor"
                                    d="M1641.177,1460.957h-.194a23.693,23.693,0,0,1,.182-47.384h.193a23.693,23.693,0,0,1-.181,47.384Zm-.012-46.874a23.212,23.212,0,1,0,.189,0Z"
                                    transform="translate(-1617.479 -1413.572)"
                                />
                            </g>
                            <g transform="translate(76.422 6.676)">
                                <path
                                    :fill="iconColor"
                                    d="M1709.9,1461.5h-.194a23.693,23.693,0,0,1,.181-47.384h.195a23.693,23.693,0,0,1-.182,47.384Zm-.012-46.874a23.181,23.181,0,0,0-.177,46.361h.189a23.181,23.181,0,0,0,23.175-23h0a23.179,23.179,0,0,0-23-23.364Z"
                                    transform="translate(-1686.203 -1414.117)"
                                />
                            </g>
                            <g transform="translate(26.385 26.391)">
                                <path
                                    :fill="iconColor"
                                    d="M1640.715,1440.232h-.027a3.425,3.425,0,1,1,2.428-.984h0A3.4,3.4,0,0,1,1640.715,1440.232Zm0-6.431a3.008,3.008,0,0,0-.024,6.016h.024a2.986,2.986,0,0,0,2.11-.865h0a3.007,3.007,0,0,0-2.111-5.151Z"
                                    transform="translate(-1637.293 -1433.388)"
                                />
                            </g>
                            <g transform="translate(57.461 25.434)">
                                <path
                                    :fill="iconColor"
                                    d="M1673.727,1434.367h0l-5.859-.046a.2.2,0,0,1-.2-.2l.011-1.466a.2.2,0,0,1,.059-.14.149.149,0,0,1,.142-.058l5.859.047a.2.2,0,0,1,.2.2l-.012,1.465A.2.2,0,0,1,1673.727,1434.367Zm-5.657-.443,5.459.043.009-1.066-5.461-.044Z"
                                    transform="translate(-1667.669 -1432.453)"
                                />
                            </g>
                            <g transform="translate(66.249 25.507)">
                                <path
                                    :fill="iconColor"
                                    d="M1682.318,1434.436h0l-5.86-.047a.2.2,0,0,1-.14-.06.2.2,0,0,1-.057-.142l.012-1.464a.2.2,0,0,1,.2-.2h0l5.858.047a.2.2,0,0,1,.2.2l-.011,1.465a.2.2,0,0,1-.2.2Zm-5.659-.445,5.461.044.008-1.066-5.46-.044Z"
                                    transform="translate(-1676.259 -1432.524)"
                                />
                            </g>
                            <g transform="translate(16.389 16.392)">
                                <path
                                    :fill="iconColor"
                                    d="M1644.61,1450.453h-.01l-7.532-.059a1.151,1.151,0,0,1-1.14-1.158l.058-7.326-7.326-.058a1.148,1.148,0,0,1-1.138-1.157l.059-7.533a1.147,1.147,0,0,1,1.148-1.14h.009l7.326.058.058-7.326a1.149,1.149,0,0,1,1.148-1.14h.01l7.532.059a1.147,1.147,0,0,1,1.139,1.159l-.057,7.325,7.327.057h0a1.151,1.151,0,0,1,1.139,1.158l-.061,7.534a1.15,1.15,0,0,1-1.149,1.14h-.009l-7.325-.058-.058,7.326a1.149,1.149,0,0,1-1.148,1.139Zm-15.881-18.017a.735.735,0,0,0-.734.729l-.059,7.533a.733.733,0,0,0,.729.74l7.532.061a.207.207,0,0,1,.2.209l-.059,7.532a.736.736,0,0,0,.728.741l7.534.059h.006a.733.733,0,0,0,.734-.729l.06-7.532a.221.221,0,0,1,.209-.207l7.533.06h0a.735.735,0,0,0,.736-.728l.06-7.533a.736.736,0,0,0-.729-.74l-7.534-.059a.207.207,0,0,1-.2-.209l.059-7.534a.733.733,0,0,0-.729-.74l-7.532-.06h-.005a.734.734,0,0,0-.735.728l-.06,7.533a.2.2,0,0,1-.061.146.175.175,0,0,1-.148.059l-7.533-.059Z"
                                    transform="translate(-1627.521 -1423.614)"
                                />
                            </g>
                            <g transform="translate(18.39 27.734)">
                                <path
                                    :fill="iconColor"
                                    d="M1633.347,1438.705h0l-3.767-.029a.1.1,0,0,1-.1-.105l.028-3.766a.115.115,0,0,1,.031-.074.109.109,0,0,1,.073-.03h0l3.768.03a.107.107,0,0,1,.092.059l.926,1.892a.1.1,0,0,1,0,.093l-.955,1.875A.1.1,0,0,1,1633.347,1438.705Zm-3.663-.235,3.6.028.9-1.772-.875-1.787-3.6-.03Z"
                                    transform="translate(-1629.477 -1434.701)"
                                />
                            </g>
                            <g transform="translate(36.295 27.885)">
                                <path
                                    :fill="iconColor"
                                    d="M1651.776,1438.852h0l-3.767-.031a.1.1,0,0,1-.091-.057l-.928-1.892a.11.11,0,0,1,0-.093l.958-1.875a.1.1,0,0,1,.092-.056h0l3.766.03a.106.106,0,0,1,.1.1l-.03,3.767A.1.1,0,0,1,1651.776,1438.852Zm-3.7-.237,3.6.03.03-3.56-3.6-.029-.9,1.772Z"
                                    transform="translate(-1646.979 -1434.848)"
                                />
                            </g>
                            <g transform="translate(27.73 36.299)">
                                <path
                                    :fill="iconColor"
                                    d="M1642.478,1448h0l-3.767-.031a.105.105,0,0,1-.1-.1l.031-3.767a.106.106,0,0,1,.057-.092l1.891-.926a.1.1,0,0,1,.093,0l1.876.957a.1.1,0,0,1,.056.092l-.03,3.767A.1.1,0,0,1,1642.478,1448Zm-3.662-.237,3.559.029.029-3.6-1.773-.9-1.786.876Z"
                                    transform="translate(-1638.607 -1443.073)"
                                />
                            </g>
                            <g transform="translate(27.88 18.393)">
                                <path
                                    :fill="iconColor"
                                    d="M1640.733,1430.5a.094.094,0,0,1-.046-.012l-1.876-.957a.1.1,0,0,1-.057-.092l.03-3.767a.1.1,0,0,1,.1-.1h0l3.766.031a.1.1,0,0,1,.1.1l-.03,3.767a.106.106,0,0,1-.058.092l-1.891.927A.1.1,0,0,1,1640.733,1430.5Zm-1.772-1.125,1.773.9,1.787-.877.029-3.6-3.56-.03Z"
                                    transform="translate(-1638.753 -1425.57)"
                                />
                            </g>
                            <g transform="translate(96.075 16.819)">
                                <path
                                    :fill="iconColor"
                                    d="M1709.487,1432.177h-.034a4.112,4.112,0,1,1,.034,0Zm0-7.745a3.674,3.674,0,0,0-.029,7.347h.031a3.65,3.65,0,0,0,2.576-1.057h0a3.672,3.672,0,0,0-2.578-6.291Z"
                                    transform="translate(-1705.414 -1424.031)"
                                />
                            </g>
                            <g transform="translate(82.875 29.808)">
                                <path
                                    :fill="iconColor"
                                    d="M1696.583,1444.875a4.071,4.071,0,0,1-2.857-6.974,3.981,3.981,0,0,1,2.889-1.172,4.073,4.073,0,0,1-.031,8.146Zm0-7.744a3.671,3.671,0,1,0,2.619,1.095A3.664,3.664,0,0,0,1696.583,1437.13Z"
                                    transform="translate(-1692.511 -1436.728)"
                                />
                            </g>
                            <g transform="translate(81.329 15.273)">
                                <path
                                    :fill="iconColor"
                                    d="M1696.693,1446.747A5.69,5.69,0,0,1,1692.7,1437l13.05-12.844a5.65,5.65,0,0,1,3.992-1.636h.046a5.693,5.693,0,0,1,3.949,9.75h0l-13.05,12.843A5.669,5.669,0,0,1,1696.693,1446.747Zm13.048-23.827a5.261,5.261,0,0,0-3.713,1.52l-13.049,12.844a5.294,5.294,0,1,0,7.426,7.546l13.05-12.844a5.293,5.293,0,0,0-3.672-9.066Zm3.855,9.208h0Z"
                                    transform="translate(-1691 -1422.52)"
                                />
                            </g>
                            <g transform="translate(109.211 22.781)">
                                <path
                                    :fill="iconColor"
                                    d="M1722.327,1438a4.072,4.072,0,1,1,0-8.144h.035a4.073,4.073,0,0,1,2.824,6.977h0A4.06,4.06,0,0,1,1722.327,1438Zm0-7.743a3.674,3.674,0,1,0,2.579,6.292h0a3.673,3.673,0,0,0-2.579-6.292Zm2.719,6.434h0Z"
                                    transform="translate(-1718.254 -1429.859)"
                                />
                            </g>
                            <g transform="translate(96.011 35.775)">
                                <path
                                    :fill="iconColor"
                                    d="M1709.424,1450.705h-.033a4.037,4.037,0,0,1-2.871-1.215,4.073,4.073,0,1,1,5.761.045l-.14-.142.14.142A4.045,4.045,0,0,1,1709.424,1450.705Zm0-7.746a3.674,3.674,0,0,0-.03,7.349,3.606,3.606,0,0,0,2.607-1.056,3.674,3.674,0,0,0-2.578-6.293Z"
                                    transform="translate(-1705.352 -1442.561)"
                                />
                            </g>
                            <g transform="translate(94.468 21.239)">
                                <path
                                    :fill="iconColor"
                                    d="M1709.534,1452.575a5.69,5.69,0,0,1-3.994-9.746l13.05-12.844a5.692,5.692,0,1,1,7.985,8.114l-.139-.142.139.142-13.048,12.844A5.674,5.674,0,0,1,1709.534,1452.575Zm13.049-23.825a5.277,5.277,0,0,0-3.713,1.519l-13.05,12.843a5.293,5.293,0,0,0,3.672,9.066h.043a5.258,5.258,0,0,0,3.713-1.521l13.049-12.843a5.291,5.291,0,0,0-3.713-9.065Z"
                                    transform="translate(-1703.843 -1428.352)"
                                />
                            </g>
                        </g>
                    </svg>
                    <p class="device-name">{{ devices[2].name }}</p>
                </li>
                <li
                    :class="{ btn: selected2.includes(devices[3].id) }"
                    @click="
                        selected2.includes(devices[3].id)
                            ? (selected2.splice(selected2.indexOf(devices[3].id), 1),
                              selectedPoint.splice(selectedPoint.indexOf(devices[3].point), 1))
                            : (selected2.push(devices[3].id), selectedPoint.push(devices[3].point)),
                            addPlanMulti()
                    "
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="notebook"
                        viewBox="0 0 279.532 141.457"
                    >
                        <g transform="translate(0.1 0.1)">
                            <g transform="translate(138.209 4.579)">
                                <path
                                    :fill="iconColor"
                                    d="M1396.724,1339.884a1.5,1.5,0,1,1,1.5-1.5.12.12,0,0,1-.241,0,1.257,1.257,0,1,0-1.258,1.258.12.12,0,0,1,0,.241Z"
                                    transform="translate(-1395.226 -1336.888)"
                                />
                            </g>
                            <g transform="translate(138.81 5.658)">
                                <path
                                    :fill="iconColor"
                                    d="M1396.854,1338.62h.9a.9.9,0,1,1-1.688-.418Z"
                                    transform="translate(-1395.958 -1338.201)"
                                />
                            </g>
                            <g transform="translate(113.376 133.246)">
                                <path
                                    :fill="iconColor"
                                    d="M1417.169,1495.554h-51.759a.411.411,0,0,1-.411-.411v-1.232a.411.411,0,0,1,.411-.411h51.759a.411.411,0,0,1,.411.411v1.232A.411.411,0,0,1,1417.169,1495.554Zm-51.348-.822h50.937v-.411h-50.937Z"
                                    transform="translate(-1365 -1493.5)"
                                />
                            </g>
                            <g transform="translate(17.747)">
                                <path
                                    :fill="iconColor"
                                    d="M1492.921,1465.177h-2.41a.409.409,0,0,1-.411-.411l.015-124.845a6.018,6.018,0,0,0-6.031-5.99H1257.056a6.019,6.019,0,0,0-6.031,5.988l.82,124.844a.411.411,0,0,1-.411.413h-2.421a.411.411,0,0,1-.411-.411V1338.3a6.992,6.992,0,0,1,6.983-6.984H1485.54a6.992,6.992,0,0,1,6.983,6.984l.808,126.466a.41.41,0,0,1-.411.413Zm-2-.822h1.586L1491.7,1338.3a6.169,6.169,0,0,0-6.162-6.164H1255.585a6.169,6.169,0,0,0-6.162,6.162v126.057h1.6l-.818-124.431v0a6.839,6.839,0,0,1,6.853-6.811h227.029a6.84,6.84,0,0,1,6.853,6.811Z"
                                    transform="translate(-1248.602 -1331.314)"
                                />
                            </g>
                            <g transform="translate(19.349 1.796)">
                                <path
                                    :fill="iconColor"
                                    d="M1396.748,1465.772h-51.758a.41.41,0,0,1-.356-.205h-92.852a.412.412,0,0,1-.411-.408l-.82-124.844a6.841,6.841,0,0,1,6.853-6.814h227.029a6.84,6.84,0,0,1,6.853,6.812l-.016,124.844a.411.411,0,0,1-.411.411H1397.1A.413.413,0,0,1,1396.748,1465.772Zm-51.4-.822h51.047a.408.408,0,0,1,.355-.206h93.7l.016-124.433a6.018,6.018,0,0,0-6.031-5.99H1257.4a6.017,6.017,0,0,0-6.03,5.99l.817,124.433h92.8A.412.412,0,0,1,1345.346,1464.951Zm140.542-3.286H1256.755a.411.411,0,0,1-.411-.411V1341.3a.41.41,0,0,1,.411-.411h229.133a.411.411,0,0,1,.411.411v119.948A.411.411,0,0,1,1485.888,1461.664Zm-228.722-.822h228.311V1341.716H1257.165Z"
                                    transform="translate(-1250.551 -1333.5)"
                                />
                            </g>
                            <g transform="translate(25.142 9.19)">
                                <path
                                    :fill="iconColor"
                                    d="M1487.146,1463.27H1258.013a.41.41,0,0,1-.411-.411V1342.911a.41.41,0,0,1,.411-.411h229.133a.411.411,0,0,1,.411.411v119.948A.411.411,0,0,1,1487.146,1463.27Zm-228.722-.822h228.311V1343.321H1258.424Z"
                                    transform="translate(-1257.602 -1342.5)"
                                />
                            </g>
                            <g transform="translate(0 133.041)">
                                <path
                                    :fill="iconColor"
                                    d="M1500.992,1501.466H1232.341a5.347,5.347,0,0,1-5.341-5.34v-.822a2.056,2.056,0,0,1,2.054-2.054h16.1a.411.411,0,1,1,0,.822h-16.1a1.234,1.234,0,0,0-1.233,1.232v.822a4.523,4.523,0,0,0,4.519,4.518h268.651a4.523,4.523,0,0,0,4.519-4.518v-.822a1.234,1.234,0,0,0-1.233-1.232h-15.212a.411.411,0,1,1,0-.822h15.212a2.055,2.055,0,0,1,2.054,2.054v.822A5.346,5.346,0,0,1,1500.992,1501.466Z"
                                    transform="translate(-1227 -1493.25)"
                                />
                            </g>
                        </g>
                    </svg>
                    <p class="device-name">{{ devices[3].name }}</p>
                </li>
                <li
                    :class="{ btn: selected2.includes(devices[4].id) }"
                    @click="
                        selected2.includes(devices[4].id)
                            ? (selected2.splice(selected2.indexOf(devices[4].id), 1),
                              selectedPoint.splice(selectedPoint.indexOf(devices[4].point), 1))
                            : (selected2.push(devices[4].id), selectedPoint.push(devices[4].point)),
                            addPlanMulti()
                    "
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="desktop"
                        viewBox="0 0 253.756 203.356"
                    >
                        <g transform="translate(0.1 0.1)">
                            <g transform="translate(0.044)">
                                <path
                                    :fill="iconColor"
                                    d="M731.644,1408.433H479.029a.426.426,0,0,1-.427-.427V1274.57a7.265,7.265,0,0,1,7.257-7.256H724.814a7.265,7.265,0,0,1,7.257,7.256v133.436A.426.426,0,0,1,731.644,1408.433Zm-252.188-.854H731.217V1274.57a6.41,6.41,0,0,0-6.4-6.4H485.859a6.41,6.41,0,0,0-6.4,6.4Z"
                                    transform="translate(-478.602 -1267.314)"
                                />
                            </g>
                            <g transform="translate(8.794 11.457)">
                                <path
                                    :fill="iconColor"
                                    d="M724.606,1401.55H489.065a.213.213,0,0,1-.214-.213V1280.948a.214.214,0,0,1,.214-.214H724.606a.214.214,0,0,1,.214.214v120.388A.213.213,0,0,1,724.606,1401.55Zm-235.327-.427H724.393V1281.161H489.279Z"
                                    transform="translate(-488.852 -1280.734)"
                                />
                            </g>
                            <g transform="translate(80.294 199.001)">
                                <path
                                    :fill="iconColor"
                                    d="M664.679,1504.566H573.494a.892.892,0,0,1-.892-.892v-2.369a.893.893,0,0,1,.892-.893h91.184a.893.893,0,0,1,.892.893v2.369A.892.892,0,0,1,664.679,1504.566Zm-91.184-3.3a.041.041,0,0,0-.039.04v2.369l91.223.038.038-2.407Z"
                                    transform="translate(-572.602 -1500.412)"
                                />
                            </g>
                            <g transform="translate(93.905 164.159)">
                                <path
                                    :fill="iconColor"
                                    d="M653.867,1495.3H588.972a.427.427,0,0,1-.1-.84c12.65-3.19,15.037-34.148,15.059-34.461a.427.427,0,0,1,.426-.4h34.133a.426.426,0,0,1,.426.4c.023.314,2.409,31.273,15.06,34.461a.427.427,0,0,1-.1.84Zm-62.6-.854h60.3c-4.545-2.376-8.144-8.455-10.716-18.122a100.8,100.8,0,0,1-2.759-15.867H604.745a100.765,100.765,0,0,1-2.758,15.866C599.415,1485.987,595.816,1492.066,591.27,1494.443Z"
                                    transform="translate(-588.545 -1459.6)"
                                />
                            </g>
                            <g transform="translate(125.219 4.759)">
                                <path
                                    :fill="iconColor"
                                    d="M626.782,1276a1.557,1.557,0,1,1,1.558-1.557.125.125,0,0,1-.251,0,1.306,1.306,0,1,0-1.307,1.307.125.125,0,1,1,0,.25Z"
                                    transform="translate(-625.225 -1272.888)"
                                />
                            </g>
                            <g transform="translate(125.845 5.88)">
                                <path
                                    :fill="iconColor"
                                    d="M626.889,1274.636h.931a.931.931,0,1,1-1.754-.435Z"
                                    transform="translate(-625.958 -1274.201)"
                                />
                            </g>
                            <g transform="translate(0 140.265)">
                                <path
                                    :fill="iconColor"
                                    d="M724.85,1456.36H485.808a7.266,7.266,0,0,1-7.257-7.257v-17.064a.427.427,0,0,1,.427-.427h252.7a.427.427,0,0,1,.427.427V1449.1A7.266,7.266,0,0,1,724.85,1456.36ZM479.4,1432.466V1449.1a6.41,6.41,0,0,0,6.4,6.4H724.85a6.41,6.41,0,0,0,6.4-6.4v-16.637Z"
                                    transform="translate(-478.551 -1431.612)"
                                />
                            </g>
                        </g>
                    </svg>
                    <p class="device-name">{{ devices[4].name }}</p>
                </li>
                <li
                    :class="{ btn: selected2.includes(devices[5].id) }"
                    @click="
                        selected2.includes(devices[5].id)
                            ? (selected2.splice(selected2.indexOf(devices[5].id), 1),
                              selectedPoint.splice(selectedPoint.indexOf(devices[5].point), 1))
                            : (selected2.push(devices[5].id), selectedPoint.push(devices[5].point)),
                            addPlanMulti()
                    "
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="smarttv"
                        viewBox="0 0 352.446 220.577"
                    >
                        <g transform="translate(0.1 0.1)">
                            <g transform="translate(127.399 198.474)">
                                <path
                                    :fill="iconColor"
                                    d="M1044,1502.4h-3.576l-44.746-4.473-44.612,4.47-3.621,0a.447.447,0,0,1-.447-.447v-3.576a.447.447,0,0,1,.353-.436l32.8-7.095,2.613-10.015a.445.445,0,0,1,.432-.334h25.943a.445.445,0,0,1,.432.334l2.613,10.016,31.911,7.093a.448.448,0,0,1,.35.436v3.576A.447.447,0,0,1,1044,1502.4Zm-48.322-5.361,44.791,4.47,3.084,0v-2.771l-31.827-7.074a.447.447,0,0,1-.335-.324l-2.6-9.947H983.546l-2.6,9.947a.444.444,0,0,1-.338.324l-32.719,7.076v2.769h3.129Z"
                                    transform="translate(-947 -1480.5)"
                                />
                            </g>
                            <g transform="translate(2.765 2.645)">
                                <path
                                    :fill="iconColor"
                                    d="M1153.8,1449.282h0l-345.986-.53a.223.223,0,0,1-.223-.224l.286-186.847a.223.223,0,0,1,.065-.158.22.22,0,0,1,.158-.065h0l345.985.53a.222.222,0,0,1,.223.223l-.286,186.847A.223.223,0,0,1,1153.8,1449.282ZM808.04,1448.3l345.538.53.286-186.4-345.539-.531Z"
                                    transform="translate(-807.593 -1261.458)"
                                />
                            </g>
                            <path
                                :fill="iconColor"
                                d="M1153.617,1457.868H807.629a3.132,3.132,0,0,1-3.129-3.129v-193.11a3.132,3.132,0,0,1,3.129-3.129h345.988a3.132,3.132,0,0,1,3.129,3.129v193.11A3.132,3.132,0,0,1,1153.617,1457.868ZM807.629,1259.394a2.238,2.238,0,0,0-2.235,2.235v193.11a2.238,2.238,0,0,0,2.235,2.235h345.988a2.237,2.237,0,0,0,2.235-2.235v-193.11a2.237,2.237,0,0,0-2.235-2.235Z"
                                transform="translate(-804.5 -1258.5)"
                            />
                            <g transform="translate(0 189.533)">
                                <path
                                    :fill="iconColor"
                                    d="M1153.617,1480.334H807.629a3.132,3.132,0,0,1-3.129-3.129v-6.258a.447.447,0,0,1,.447-.447H1156.3a.447.447,0,0,1,.447.447v6.258A3.132,3.132,0,0,1,1153.617,1480.334Zm-348.223-8.94v5.811a2.238,2.238,0,0,0,2.235,2.235h345.988a2.237,2.237,0,0,0,2.235-2.235v-5.811Z"
                                    transform="translate(-804.5 -1470.5)"
                                />
                            </g>
                            <g transform="translate(338.389 193.557)">
                                <path
                                    :fill="iconColor"
                                    d="M1189.7,1475.894h-6.258a.447.447,0,0,1,0-.894h6.258a.447.447,0,1,1,0,.894Z"
                                    transform="translate(-1183 -1475)"
                                />
                            </g>
                        </g>
                    </svg>
                    <p class="device-name">{{ devices[5].name }}</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "Devices",
    props: ["points"],
    data() {
        return {
            devices: [
                {
                    name: "Smartphone",
                    id: 0,
                    point: this.points[6].item_points
                },
                {
                    name: "Tablet",
                    id: 1,
                    point: this.points[7].item_points
                },
                {
                    name: "Videogame",
                    id: 2,
                    point: this.points[8].item_points
                },
                {
                    name: "notebook",
                    id: 3,
                    point: this.points[9].item_points
                },
                {
                    name: "computador",
                    id: 4,
                    point: this.points[10].item_points
                },
                {
                    name: "smart tv",
                    id: 5,
                    point: this.points[11].item_points
                }
            ],
            iconColor: "#ff8412",
            selected2: [],
            selectedPoint: []
        };
    },
    methods: {
        addPlanMulti() {
            this.$store.commit(
                "ADD_PLAN_MULTI",
                this.selectedPoint.reduce((a, b) => a + b, 0)
            );
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../styles/style";

li.btn p {
    color: $purple;
}

li.btn svg path {
    fill: $purple;
}

.smartphone {
    width: 90px;
    height: 157px;
}

.tablet {
    width: 148px;
    height: 201px;
}
.videogame {
    width: 116px;
    height: 54px;
}

.notebook {
    width: 204px;
    height: 103px;
}

.desktop {
    width: 214px;
    height: 172px;
}

.smarttv {
    width: 274px;
    height: 171px;
}

.btn::before {
    content: url("../../public/Polígono_1.png");
    color: $purple;
    position: absolute;
    top: -5px;
    left: 50%;
    transform: translate(-50%, -50%);
}

p {
    text-align: left;
    font-size: 21px;
    color: #ff8412;
    font-weight: 500;
}

.device-name {
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    text-transform: uppercase;
    margin-top: 20px;
}

::-webkit-scrollbar {
    width: 7px;
}

::-webkit-scrollbar-track {
    background: #e0e0e0;
    border-radius: 6px;
}

::-webkit-scrollbar-thumb {
    background: #ff8711;
    border-radius: 6px;
}

@media only screen and (min-width: 1024px) {
    .slide {
        margin-top: 1em;

        ul {
            display: flex;
            flex-wrap: wrap;
            align-items: baseline;

            div {
                display: flex;
                align-items: baseline;
            }

            li {
                width: 200px;
                padding-top: 1rem;
                padding-bottom: 3rem;
                position: relative;
                cursor: pointer;
                text-align: center;
            }
        }
    }

    .smartphone {
        width: 45px;
        height: 79px;
    }

    .tablet {
        width: 68px;
        height: 92px;
    }
    .videogame {
        width: 56px;
        height: 26px;
    }

    .notebook {
        width: 119px;
        height: 60px;
    }

    .desktop {
        width: 108px;
        height: 87px;
    }

    .smarttv {
        width: 139px;
        height: 94px;
    }
}

@media only screen and (max-width: 600px) {
    .wrapper-devices {
        padding: 1em;
    }
    .slide {
        text-align-last: center;

        ul {
            display: flex;
            flex-wrap: wrap;
            min-width: 296px;
            margin-top: 2em;

            li {
                min-width: 112px;
                margin-right: 0;
                display: flex;
                flex-direction: column;
                padding-bottom: 2.6rem;
                position: relative;
                align-items: center;
            }

            li:nth-child(odd) {
                margin-right: 2.5em;
            }

            li:nth-child(1) {
                margin-right: 3em;
            }
            li:nth-child(3) {
                margin-right: 3em;
            }
        }
    }

    .mobile-row {
        display: flex;
        align-items: baseline;
    }

    .btn::before {
        top: -11%;
    }

    p {
        text-align: left;
    }

    .device-name-game {
        margin-top: 54px;
    }

    .device-name-phone {
        margin-top: 33px;
    }

    .smartphone {
        width: 45px;
        height: 79px;
    }

    .tablet {
        width: 68px;
        height: 92px;
    }
    .videogame {
        width: 56px;
        height: 26px;
    }

    .notebook {
        width: 119px;
        height: 60px;
    }

    .desktop {
        width: 108px;
        height: 87px;
    }

    .smarttv {
        width: 139px;
        height: 94px;
    }
}

.obs {
    font-size: 14px;
    color: #6c4d90;
    margin-top: 10px;
}
</style>
